module.exports = __webpack_public_path__ + "img/6f_r_twodays_1.481592ae.png";